import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import { rhythm } from "../utils/typography"

function Bio() {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const { author, social } = data.site.siteMetadata
        return (
          <React.Fragment>
            <div
              style={{
                display: "flex",
                alignItems: "center"
              }}
            >
              <Image
                fixed={data.avatar.childImageSharp.fixed}
                alt={author}
                style={{
                  marginRight: rhythm(1 / 2),
                  marginBottom: 0,
                  minWidth: 50,
                  borderRadius: `100%`
                }}
              />
              <h1
                style={{
                  fontWeight: 300,
                  margin: 0
                }}
              >
                Hello, my name is <strong>Carl</strong>
              </h1>
            </div>
            <p>
              I'm a developer with a passion for creativity and turning ideas
              into code.
              {/* I create with code and write about ideas. */}
            </p>
            {/* <p>
              Below are some of the projects I've built or currently working on.
            </p> */}
          </React.Fragment>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`

export default Bio
